import React from 'react';
import PropTypes from 'prop-types';
import { th } from 'style/theme';
import Status from 'components/StatusIndicator';
import {
  Container,
  Content,
  Footer,
  DesktopButtons,
  MobileButtons,
  Text,
  Progress,
  ClaimType,
  ProgressionBar,
  Price,
  Label,
  ClaimIdWrapper
} from './styled';
import { ClaimTypeInfo } from '../ClaimTypeInfo';
import ClaimProgress from '../ClaimProgress';
import { ClaimAmountInfo } from '../ClaimAmountInfo';
import ClaimantInfo from '../ClaimantInfo';
import ClaimIDInfo from '../ClaimIDInfo';
import ClaimActionButtons from '../ClaimActionButtons';
import useClaimProgression from '../../hooks/useClaimProgression';

const ClaimRow = ({ claim }) => {
  const { progress } = useClaimProgression(claim);

  return (
    <Container>
      <Content>
        <Progress>
          <Status label={progress?.label} color={th(`colors.${progress?.color}`)} />
        </Progress>
        <ClaimType>
          <ClaimTypeInfo claimType={claim.claimType} />
        </ClaimType>
        <ProgressionBar>{progress && <ClaimProgress claim={claim} />}</ProgressionBar>
        <Price>
          <ClaimAmountInfo claim={claim} />
        </Price>
        <MobileButtons>
          <ClaimActionButtons claim={claim} />
        </MobileButtons>
      </Content>
      <Footer>
        <ClaimIDInfo eobNumber={claim.eobNumber} />
        <ClaimantInfo claimFullName={claim.claimFullName} />
        <DesktopButtons>
          <ClaimActionButtons claim={claim} />
        </DesktopButtons>
      </Footer>
    </Container>
  );
};

ClaimRow.propTypes = {
  claim: PropTypes.any.isRequired
};

export default ClaimRow;
